import Link from "next/link";
import { getGlobalData } from "utils/api";
import { getLocalizedPaths } from "utils/localize";
import Image from "next/image";

import { RefreshHeader } from "@/components/brandRefresh/common/PageTemplate";
import useSearchWithBreadCrumbs from "@/components/brandRefresh/common/use-search-with-breadcrumbs";

const fraudLinks = [
  {
    title: "How to keep yourself safe",
    description:
      "Tips on best practices, latest scams and what to look out for.",
    link: "fraud-prevention/keep-safe",
  },
  {
    title: "How to report fraud",
    description:
      "Seen a payment on your bank statement or seen us on your credit file and don't know who we are?",
    link: "fraud-prevention/report-fraud",
  },
  {
    title: "Issue with a transaction",
    description:
      "Don't recognise a transaction on your statement or an amount looks unusual.",
    link: "fraud-prevention/issue-transaction",
  },
  // {
  //   title: "Article Hub",
  //   description:
  //     "Prior correspondence communicated on best practices and seasonal risks.",
  //   link: "fraud-prevention/article-hub",
  // },
];
const searchFilterCallback = (fraudLinks = [], search = "") =>
  fraudLinks.filter(link =>
    link.title.toLowerCase().includes(search.toLowerCase()),
  );

export default function FraudPrevention({ metadata }) {
  const { renderSearchView, filteredValues: customerFraudLinks } =
    useSearchWithBreadCrumbs({
      defaultValues: fraudLinks,
      searchFilterCallback,
      showAutoCompleteDropDown: false,
    });

  return (
    <RefreshHeader metadata={metadata}>
      <div className="text-sm md:text-base 4xl:text-xl">
        {renderSearchView()}

        <div className="flex flex-col gap-4 ">
          {customerFraudLinks.map(item => {
            return (
              <Link
                className="bg-onmoPurple-50 px-6 md:px-10 py-6 text-onmoPrimary rounded-xl text-base md:text-xl 4xl:text-2xl font-medium"
                key={item.title}
                href={item.link}
              >
                <div className="flex justify-between items-center">
                  <div>
                    <span className="mb-2 block">{item.title}</span>
                    <span className="text-onmoGrey text-base 4xl:text-xl font-normal block">
                      {item.description}
                    </span>
                  </div>
                  <Image
                    src="/images/icons/chevron-right.svg"
                    alt="chevron-right-icon"
                    className="h-6 w-6"
                    height="24"
                    width="24"
                  />
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </RefreshHeader>
  );
}

export async function getServerSideProps(context) {
  const { locale, locales, defaultLocale } = context;
  const globalLocale = await getGlobalData(locale);

  const pageContext = {
    locale,
    locales,
    defaultLocale,
    slug: context.resolvedUrl.replace(/\//g, ""),
  };

  const localizedPaths = getLocalizedPaths(pageContext);

  const metadata = {
    metaTitle: `Fraud Prevention`,
  };

  return {
    props: {
      metadata,
      global: globalLocale.data,
      pageContext: {
        ...pageContext,
        localizedPaths,
      },
    },
  };
}
